import axios from "axios";
import {
  CHECK_SLUG_DEALOFTHEDAY,
  CREATE_DEALOFTHEDAY,
  DEALOFTHEDAY_NOTIFICATION,
  DELETE_DEALOFTHEDAY,
  EDIT_DEALOFTHEDAY,
  ENABLE_DISABLE_DEALOFTHEDAY,
  GET_DEALOFTHEDAY,
  GET_DEALOFTHEDAY_DETAILS,
} from "../../constants/ApiConstant";
import { ToastMessage } from "../../utils/Helper";
import { REDIRECT_PATH } from "../../Routes";
import { get_Products } from "../productsApi/ProductsApi";
import { get_Category_Master } from "../categoryApi/CategoryApi";
import { get_Store } from "../storeApi/StoreApi";
import { DISCOUNT_APPLY_TYPE, DISCOUNT_TYPE } from "../../constants";

/**
 * get deal of the day list data
 * @param {pagination params} paramsObj
 * @returns data response
 */

export const get_Deal_Of_The_Day = (paramsObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_DEALOFTHEDAY}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
    })
    .then((res) => res.data);
};

/**
 * add deal of the day api call
 * @param {form data} formData
 * @param {deal of the day list function} refetch
 * @param {modal close} setdialogs
 * @param {emptyData} emptyData
 * @returns
 */

export const Create_Deal_Of_The_Day = (formData, history, emptyData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .post(`${process.env.REACT_APP_API_URL}${CREATE_DEALOFTHEDAY}`, formData, {
      headers: { Authorization: jwt_token },
    })
    .then((message) => {
      emptyData();
      ToastMessage(message.status, message.data.message);
      history(`${REDIRECT_PATH.DEALOFTHEDAY}`);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 *enable - disable deal of the day api call
 * @param {form data as isActive & dealId} formData
 * @param {list api call function} refetch
 * @returns true & false
 */

export const Enable_Disable_Deal_Of_The_Day = (formData, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}${ENABLE_DISABLE_DEALOFTHEDAY}`,
      formData,
      {
        headers: { Authorization: jwt_token },
        params: { dealId: formData.dealId },
      }
    )
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      if (error.response) {
        const { status, message } = error?.response?.data || error;
        ToastMessage(status, message);
      }
    });
};

/**
 * get details deal of the day
 * @param {*} dealId
 * @param {form data func} setFormData
 * @param {modal func} setdialogs
 * @returns
 */
export const Get_Details_Deal_Of_The_Day = (dealId, history, setFormData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_DEALOFTHEDAY_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: { dealId },
    })
    .then(async (res) => {
      let data = res.data.payload.data;
      let paramObj = {
        showAll: true,
      };

      let responseStore = await get_Store(paramObj);
      [responseStore] = responseStore?.payload?.data?.filter(
        (elem) => elem?.storeId === data?.storeId
      );
      let responseProduct = await get_Products(paramObj);
      [responseProduct] = responseProduct?.payload?.data?.filter(
        (elem) => elem?.productId === data?.productId
      );
      let responseCategory = await get_Category_Master(paramObj);
      [responseCategory] = responseCategory?.payload?.data?.filter(
        (elem) => elem?.catId === data?.catId
      );
      let [responseDiscountType] = DISCOUNT_TYPE?.filter(
        (elem) => elem?.code === data?.discountType
      );
      let [responseApplyType] = DISCOUNT_APPLY_TYPE?.filter(
        (elem) => elem?.code === data?.applyType
      );
      setFormData({
        storeId: data?.storeId,
        applyType: data
          ? {
              name: responseApplyType?.name,
              code: responseApplyType?.code,
            }
          : null,
        discountType: data
          ? {
              name: responseDiscountType?.name,
              code: responseDiscountType?.code,
            }
          : null,

        discountValue: data?.discountValue,
        maxDiscountAmount: data?.maxDiscountAmount,
        minOrderAmount: data?.minOrderAmount,

        dealOfTheDay: data ? data?.dealOfTheDay : "",
        assignStores: data
          ? {
              name: responseStore?.name,
              code: responseStore?.storeId,
            }
          : null,
        productId: data?.productId
          ? {
              code: responseProduct?.productId,
              name: responseProduct?.productName,
            }
          : null,
        catId: data?.catId
          ? {
              code: responseCategory.catId,
              name: responseCategory.name,
            }
          : null,
        startDate: data
          ? [new Date(data?.startDate), new Date(data?.endDate)]
          : "",
        endDate: data ? data?.endDate : "",
      });
      history(`${REDIRECT_PATH.DEALOFTHEDAY}/${dealId}`);
      return res;
    });
};

/**
 * update deal of the day api call
 * @param {form data} formData
 * @param {*} dealId
 * @param {list api call } refetch
 * @param {modal func} setdialogs
 * @param {emptyData} emptyData
 * @returns
 */

export const Put_Update_Deal_Of_The_Day = (
  formData,
  dealId,
  history,
  emptyData
) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(`${process.env.REACT_APP_API_URL}${EDIT_DEALOFTHEDAY}`, formData, {
      headers: { Authorization: jwt_token },
      params: { dealId },
    })
    .then((message) => {
      emptyData();
      ToastMessage(message.status, message.data.message);
      history(`${REDIRECT_PATH.DEALOFTHEDAY}`);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 * delete deal of the day api call
 * @param {form data} formData
 * @param {*} brandId
 * @param {list api call } refetch
 * @returns
 */

export const Delete_Deal_Of_The_Day = (dealId, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .delete(`${process.env.REACT_APP_API_URL}${DELETE_DEALOFTHEDAY}`, {
      headers: { Authorization: jwt_token },
      params: { dealId },
    })
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 * check slug deal of the day api call
 * @param {form data} formData
 * @param {*} catId
 * @param {list api call } refetch
 * @param {modal func} setdialogs
 * @param {form data func} setFormData
 * @returns
 */

export const Get_Check_Slug_Url = (formData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${CHECK_SLUG_DEALOFTHEDAY}`, {
      headers: { Authorization: jwt_token },
      params: formData,
    })
    .then((message) => {})
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

export const Put_Notification_Send = (formData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}${DEALOFTHEDAY_NOTIFICATION}`,
      formData,
      {
        headers: { Authorization: jwt_token },
      }
    )
    .then((message) => {
      ToastMessage(message.status, message.data.message);
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};
